import { IPrivileges } from 'Store/IPrivileges';
import { Action } from 'redux';

export enum PrivilegesActionTypes {
    Set = 'SET_PRIVILEGES',
    Clear = 'CLEAR_PRIVILEGES'
};

export interface SetPrivileges extends Action{
    type: PrivilegesActionTypes.Set,
    privileges: IPrivileges
}

export interface ClearPrivileges extends Action {
    type: PrivilegesActionTypes.Clear
}